const handleApiError = (message: string, err: unknown): never => {
    console.error(message, err)
    throw new Error(message)
}

export default handleApiError